import { ContextHelpButton } from "@/components/registrant/help/context-help-button";
import { HelpArticleBody } from "@/components/registrant/help/help-article-body";
import { getHelpArticle } from "@/lib/registrant-help";

/** @deprecated Use ContextHelpButton with articleId="user-management". */
export function UserManagementHelpContent() {
  const article = getHelpArticle("user-management");
  if (!article) {
    return null;
  }
  return <HelpArticleBody article={article} />;
}

export function UserManagementHelpButton() {
  return <ContextHelpButton articleId="user-management" />;
}
